import React from "react";
import { SettingsIcon } from "../../images/SettingsIcon";
import { Padding } from "../../shared-components/Padding";
import {
    DARKENED_BACKGROUND_COLOR,
    HORIZONTAL_RULE_COLOR,
    RUBRIC_COLOR,
} from "../../tokens";
import { Setting } from "./Setting";

export const SettingsPage: React.FC<{}> = () => {
    return (
        <Padding>
            <div
                style={{
                    fontWeight: "bold",
                    letterSpacing: 2,
                    textTransform: "uppercase",
                    fontSize: "140%",
                    paddingBottom: 32,
                    paddingTop: 32,
                    textAlign: "center",
                }}
            >
                Settings
            </div>
            <div
                style={{
                    backgroundColor: DARKENED_BACKGROUND_COLOR,
                    border: `0.5px solid ${HORIZONTAL_RULE_COLOR}`,
                    paddingTop: 6,
                    paddingBottom: 8,
                    paddingLeft: 12,
                    paddingRight: 12,
                    borderRadius: 4,
                }}
            >
                <span
                    style={{
                        color: RUBRIC_COLOR,
                        fontWeight: "bold",
                        fontSize: "90%",
                    }}
                >
                    NOTE:
                </span>{" "}
                It is easier to change the settings by pressing the{" "}
                <SettingsIcon /> button next to the relevant part of the
                liturgy.
            </div>
            <Setting setting="absolution" />
            <Setting setting="lordsPrayerAfterConfession" />
            <Setting setting="psalmCycle" />
            <Setting setting="lectionary" />
            <Setting setting="secondReadingToCompline" />
            <Setting setting="bibleTranslation" />
            <Setting setting="psalmsAtCompline" />
            <Setting setting="psalmsBold" />
            <Setting setting="invitatoryAntiphons" />
            <Setting setting="antiphonTones" />
            <Setting setting="teDeum" />
            <Setting setting="salutation" />
            <Setting setting="lordsPrayer" />
            <Setting setting="monarch" />
            <Setting setting="adventAndLentCollects" />
            <Setting setting="letUsBlessMattinsAndEvensong" />
            <Setting setting="hymnPosition" />
            <Setting setting="canticleAntiphonsExperimental" />
            <Setting setting="canticleTonesExperimental" />
            <Setting setting="experimentalChantRendering" />
        </Padding>
    );
};
